import { updateSpeedInfo, onTaskFinished } from './state';
import { setLogString } from "./frontend-log";

let socket = null;
export function connectTaskWS(taskId) {
  if (socket && (socket.readyState === WebSocket.OPEN || socket.readyState === WebSocket.CONNECTING)) {
    socket.close();
  }

  const protocol = window.location.protocol === 'https:' ? 'wss://' : 'ws://';
  const wsUrl = `${protocol}${window.location.host}/ws/task/${taskId}/`;
  socket = new WebSocket(wsUrl);

  socket.onopen = function() {
    console.log("WS connected");
  };

  socket.onmessage = function(e) {
    const data = JSON.parse(e.data);
    if (data.type === 'task_update') {
      const checkedEl = document.getElementById('checked-emails');
      const validEl = document.getElementById('valid-emails');
      const invalidEl = document.getElementById('invalid-emails');
      if (checkedEl) checkedEl.textContent = data.checked_emails;
      if (validEl) validEl.textContent = data.valid_emails;
      if (invalidEl) invalidEl.textContent = data.invalid_emails;
      const unknownEl = document.getElementById('unknown-emails');
      if (unknownEl) unknownEl.textContent = data.unknown_emails || 0;
      updateSpeedInfo(data);

      if (['completed', 'failed', 'cancelled'].includes(data.status)) {
        onTaskFinished(taskId, data.status);
      }
    }
    if (data.type === 'log_update') {
      setLogString(data.log_str);
    }
  };

  socket.onclose = function() {
    console.log("WS disconnected");
  };
}
